package com.example.mystybag.appCore.logic

import com.example.mystybag.appCore.model.PhoneSelectionBottomSheetUIState
import com.example.mystybag.communication.common.CommonCommands
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.common.logic.BSNavigatorPhoneInput
import com.example.mystybag.core.extensions.isValidPhone
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.helpers.GlobalCommonData.getDialCodeValue
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.model.CountryItem
import com.example.mystybag.common.resources.SR

class PhoneSelectionBottomSheetViewModel(
    context: AppContext,
    private val config: BSNavigatorPhoneInput
) : ChildViewModel<PhoneSelectionBottomSheetUIState>(
    context,
    PhoneSelectionBottomSheetUIState(
        dialCode = config.initialDialCode,
        phoneNumber = config.initialPhoneNumber
    )
) {

    override fun onCreate() {
        loadCountries()
    }

    private fun loadCountries() {
        updateState { it.copy(isLoading = true) }
        commandBlock(showProgress = false) {
            CommonCommands.sendGetCountries()
                .onResponse(
                    success = { response ->
                        launchOnMain {
                            val countries = response.countriesList?.map { country ->
                                CountryItem(
                                    id = country.id,
                                    name = country.name,
                                    dialCode = country.dialCode,
                                    isoAlpha2 = country.isoAlpha2
                                )
                            } ?: emptyList()
                            updateState {
                                it.copy(countries = countries, isLoading = false)
                            }
                        }
                    },
                    baseError = {
                        launchOnMain {
                            updateState { it.copy(isLoading = false) }
                            showSnackbar(com.example.mystybag.communication.utils.Response.getErrorMessage(it.status, it.apiEndPoint, it.statusMessage))
                        }
                    }
                )
        }
    }

    fun showCountryPicker() {
        updateState { it.copy(showCountryPicker = true) }
    }

    fun hideCountryPicker() {
        updateState { it.copy(showCountryPicker = false) }
    }

    fun selectDialCodeCountry(dialCode: String) {
        updateState {
            it.copy(dialCode = dialCode, showCountryPicker = false)
        }
    }

    fun onPhoneNumberChanged(phoneNumber: String) {
        updateState { it.copy(phoneNumber = phoneNumber) }
    }

    fun onSaveClicked() {
        val state = uiState.value
        when {
            state.dialCode.isBlank() -> showSnackbar(sharedString(SR.strings.please_enter_all_required_fields))
            state.phoneNumber.isBlank() -> showSnackbar(sharedString(SR.strings.invalid_phone_number))
            !state.phoneNumber.isValidPhone -> showSnackbar(sharedString(SR.strings.invalid_phone_number))
            else -> {
                config.onPhoneSelected(state.dialCode, state.phoneNumber)
                closeBottomSheet()
            }
        }
    }
}
